<template>
  <v-card>
    <v-card-title class="text-center justify-center">
      <h1
        class="display-2 font-weight-light"
        style="margin-top: 20px; padding-bottom: 20px;"
      >Heterogeneous Accelerated Compute Cluster (HACC) at NUS</h1>
    </v-card-title>

    <v-container fluid>
      <v-row>
        <v-col v-for="card in cards" :key="card.title" :cols="card.flex">
          <v-img
            v-on:click.native="showContent(card.component)"
            :src="card.src"
            class="white--text align-end"
            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
            height="200px"
          >
            <v-card-title v-text="card.title"></v-card-title>
          </v-img>
        </v-col>
      </v-row>
    </v-container>
    <component v-bind:is="component"></component>
  </v-card>
</template>

<script>
import FPGAIntro from "./FPGAIntro.vue";
import ClusterInfra from "./ClusterInfra.vue";
import UserGuide from "./UserGuide.vue";

export default {
  components: {
    "fpga-intro": FPGAIntro,
    "cluster-infra": ClusterInfra,
    "user-guide": UserGuide,
  },

  methods: {
    showContent: function (component) {
      this.component = component;
    },
  },

  data: () => ({
    cards: [
      {
        title: "Workshop",
        src: require("./../assets/fpga.jpg"),
        flex: 4,
        component: "fpga-intro",
      },
      {
        title: "User Guide",
        src: require("./../assets/cluster.jpg"),
        flex: 4,
        component: "cluster-infra",
      },
      {
        title: "Booking System",
        src: require("./../assets/schedule.jpg"),
        flex: 4,
        component: "user-guide",
      },
    ],
    component: "cluster-infra",
  }),
};
</script>
